export function forceNumericCoordinate(coordinate) {
    if (typeof coordinate === "number") {
        return coordinate;
    } else if (typeof coordinate === "string") {
        const parsed = parseFloat(coordinate.replace(",", "."));
        return isNaN(parsed) ? 0 : parsed;
    }
    return 0;
}
